module.exports = __webpack_public_path__ + "img/white-logo.e8d4897b.svg";